
import Text from '../../../common/Text.js';
import React, { useState } from 'react';
import arrow_D from '../../HumanResource/img/ep_arrow-down-bold.png';
import arrow_U from '../../HumanResource/img/ep_arrow-up-bold.png';
import '../../CompanyInfo/css/JobIntroduction.css'





function JobIntroDuction_Card({ group, summary, detail, id, index, setIndex }) {

      const [isActive, setIsActive] = useState(false);


      function handleBtnClick() {
            setIsActive(!isActive);
            setIndex(id);
      }
      return (
            <div className={isActive && id === index ? 'borderbox1 active' : 'borderbox1'} onClick={() => handleBtnClick()} >
                  <div className='boxitem'>
                        <div className='borderboxtitle'>
                              {group}
                        </div>
                        <div className='borderboxsubtitle'>
                              {summary}
                        </div>
                        <div className={isActive && id === index ? 'borderhiddentext active' : 'borderhiddentext'}>
                              <div className='borderboxhr' />
                              <div>
                                    {detail}
                              </div>
                        </div>
                  </div>
                  <button className={isActive && id === index ? 'borderboxarrow active' : 'borderboxarrow'} >
                        <img src={isActive && id === index ? arrow_U : arrow_D}
                              className='arrowImage'></img>
                  </button>
            </div>

      );

}

export default JobIntroDuction_Card;